/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoZuChaXunTiaoJian,
  GuangGaoZuChuangJianXinXi,
  GuangGaoZuYuSuanBianJi,
  PiLiangGuangGaoZuChuJiaBianJi1,
  PiLiangGuangGaoZuYuSuanBianJi,
  PiLiangGuangGaoZuZhuangTaiBianJi,
  ResponseApiGuangGaoZuChuangJianXiangYing,
  ResponseApiGuangGaoZuXiangQing,
  ResponseApiIPageGuangGaoZuLieBiao,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoZuGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name BatchUpdateAdGroupBidPriceUsingPut
   * @summary 批量更新广告组出价
   * @request PUT:/dsp-admin/api/adgroup/batch/bid-price
   * @secure
   */
  batchUpdateAdGroupBidPriceUsingPut = (
    batchBidPriceUpdateDTO: PiLiangGuangGaoZuChuJiaBianJi1,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/batch/bid-price`,
      method: "PUT",
      body: batchBidPriceUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name BatchUpdateAdGroupBudgetUsingPut
   * @summary 批量更新广告组预算
   * @request PUT:/dsp-admin/api/adgroup/batch/budget
   * @secure
   */
  batchUpdateAdGroupBudgetUsingPut = (
    batchBudgetUpdateDTO: PiLiangGuangGaoZuYuSuanBianJi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/batch/budget`,
      method: "PUT",
      body: batchBudgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name BatchUpdateAdGroupStatusUsingPut
   * @summary 批量更新广告组状态（启用/暂停）
   * @request PUT:/dsp-admin/api/adgroup/batch/status
   * @secure
   */
  batchUpdateAdGroupStatusUsingPut = (
    batchStatusUpdateDTO: PiLiangGuangGaoZuZhuangTaiBianJi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/batch/status`,
      method: "PUT",
      body: batchStatusUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name CreateAdGroupUsingPost
   * @summary 创建广告组
   * @request POST:/dsp-admin/api/adgroup/create
   * @secure
   */
  createAdGroupUsingPost = (
    createDTO: GuangGaoZuChuangJianXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiGuangGaoZuChuangJianXiangYing, void>({
      path: `/dsp-admin/api/adgroup/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name AdGroupListUsingPost
   * @summary 分页查询广告组列表
   * @request POST:/dsp-admin/api/adgroup/list
   * @secure
   */
  adGroupListUsingPost = (
    查询条件参数: GuangGaoZuChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoZuLieBiao, void>({
      path: `/dsp-admin/api/adgroup/list`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name GetAdGroupUsingPost
   * @summary 获取广告组详情
   * @request POST:/dsp-admin/api/adgroup/{id}
   * @secure
   */
  getAdGroupUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoZuXiangQing, void>({
      path: `/dsp-admin/api/adgroup/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name UpdateAdGroupUsingPut
   * @summary 更新广告组
   * @request PUT:/dsp-admin/api/adgroup/{id}
   * @secure
   */
  updateAdGroupUsingPut = (
    createDTO: GuangGaoZuChuangJianXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiGuangGaoZuChuangJianXiangYing, void>({
      path: `/dsp-admin/api/adgroup/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name DeleteAdGroupUsingDelete
   * @summary 删除广告组
   * @request DELETE:/dsp-admin/api/adgroup/{id}
   * @secure
   */
  deleteAdGroupUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name UpdateAdGroupBudgetUsingPut
   * @summary 更新广告组预算
   * @request PUT:/dsp-admin/api/adgroup/{id}/budget
   * @secure
   */
  updateAdGroupBudgetUsingPut = (
    budgetUpdateDTO: GuangGaoZuYuSuanBianJi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/${id}/budget`,
      method: "PUT",
      body: budgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name PauseAdGroupUsingPut
   * @summary 暂停广告组
   * @request PUT:/dsp-admin/api/adgroup/{id}/pause
   * @secure
   */
  pauseAdGroupUsingPut = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/${id}/pause`,
      method: "PUT",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZuGuanLi
   * @name ResumeAdGroupUsingPut
   * @summary 恢复广告组
   * @request PUT:/dsp-admin/api/adgroup/{id}/resume
   * @secure
   */
  resumeAdGroupUsingPut = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/adgroup/${id}/resume`,
      method: "PUT",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoZuGuanLi();
